export default "__VITE_ASSET__CX6YSJ1q__"